<template>
    <div class="user-multiple-form needs-validation pt-5 pb-5 w-100">
        <div class="d-flex justify-content-center h-50 align-items-center" v-if="$store.state.loading">
            <b-spinner variant="info" style="width: 7rem; height: 7rem;"/>
        </div>
        <div class="user-multiple-form__row align-items-center" v-show="!$store.state.loading">
            <address-settings/>
            <b-col md="10">
                <ShippingPolicy />
            </b-col>
        </div>
    </div>
</template>

<script>
    import AddressSettings from '~cp/UserPanel/Elements/AddressSettings'
    import ShippingPolicy from '~cp/UserPanel/Elements/ShippingPolicySettings/ShippingPolicy'

    export default {
        name: 'ShippingSettings',
        components: {
            AddressSettings,
            ShippingPolicy
        },
        data() {
            return {
            }
        },
        created() {
            if (!this.$store.getters.hasDefaultAddress) {
                this.shownAlert()
            }
        },
        methods: {
            shownAlert() {
                this.$store.dispatch('globalAlertAction', {
                    type: 'warning',
                    title: 'You can\'t work with Boxiti without Default Address!',
                    message: 'Please, add Default Address.',
                    timeout: 15000
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/UserSettings/ShippingSettings.vue